import React from 'react';
import './App.css';
import Mainroutes from './pages/Mainroutes';
import WordGuess from './pages/WordGuess';
function App() {
  return (
    <>
      <Mainroutes />
      
    </>
  );
}

export default App;
